import type { AlertBody } from '@protector/entities/alerts/models';

export const AlertsActionsTypes = {
  LOAD_ALERTS: '[Alerts] Load Alerts',
  LOAD_ALERTS_SUCCESS: '[Alerts] Load Alerts Success',
  LOAD_ALERTS_FAILURE: '[Alerts] Load Alerts Failure'
} as const;

export const LoadAlerts = () => {
  return {
    type: AlertsActionsTypes.LOAD_ALERTS
  };
};

export const LoadAlertsSuccess = (alerts: AlertBody[]) => {
  return {
    type: AlertsActionsTypes.LOAD_ALERTS_SUCCESS,
    payload: alerts
  };
};

export const LoadAlertsFailure = (error: string) => {
  return {
    type: AlertsActionsTypes.LOAD_ALERTS_FAILURE,
    payload: error
  };
};
